<div class="cpcontent">
    <h2>Users</h2>
    <button id="addnewuser"class="btn btn-primary" (click)="add()">New User</button>
    <br><br>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Name <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('firstName')"></i></th>
                <th>Username</th>
                <th >Organization<i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('organization')"></i></th>
                <th>Email</th>
                <th>Phone</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of users">
                <td class="link" (click)="edituser(user)">
                    <button style=" background-color: white; border: none" class="link" id="{{user.userName}}">{{user.firstName}} {{user.lastName}}</button>
                </td>
                <td>{{user.userName}}</td>
                <td>{{lookup(user.organizationId,organizations)}}</td>
                <td>{{user.email}}</td>
                <td>{{user.phone}}</td>
            </tr>
        </tbody>
    </table>
</div>